var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcademicInfoBlackFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6223 11.7301C13.1248 11.4001 13.7848 11.7601 13.7848 12.3601V13.3276C13.7848 14.2801 13.0423 15.3001 12.1498 15.6001L9.75734 16.3951C9.33734 16.5376 8.65484 16.5376 8.24234 16.3951L5.84984 15.6001C4.94984 15.3001 4.21484 14.2801 4.21484 13.3276V12.3526C4.21484 11.7601 4.87484 11.4001 5.36984 11.7226L6.91484 12.7276C7.50734 13.1251 8.25734 13.3201 9.00734 13.3201C9.75734 13.3201 10.5073 13.1251 11.0998 12.7276L12.6223 11.7301Z",
    fill: "#0E0C0B",
    fillOpacity: 0.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9851 4.84492L10.4926 1.89742C9.68264 1.36492 8.34764 1.36492 7.53764 1.89742L3.02264 4.84492C1.57514 5.78242 1.57514 7.90492 3.02264 8.84992L4.22264 9.62992L7.53764 11.7899C8.34764 12.3224 9.68264 12.3224 10.4926 11.7899L13.7851 9.62992L14.8126 8.95492V11.2499C14.8126 11.5574 15.0676 11.8124 15.3751 11.8124C15.6826 11.8124 15.9376 11.5574 15.9376 11.2499V7.55992C16.2376 6.59242 15.9301 5.46742 14.9851 4.84492Z",
    fill: "#0E0C0B",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcademicInfoBlackFilled);
export default __webpack_public_path__ + "static/media/academic_info_black_filled.8eee6b24f069e3353c49853a56b5103c.svg";
export { ForwardRef as ReactComponent };